// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__1YT46","goToPresaleBtn":"styles_goToPresaleBtn__fCGWR"};